import React, { useState } from "react";
import StoreShop from "./store/StoreShop";
import StoreCheckout from "./store/StoreCheckout";
import axios from "axios";
import { headerPublic } from '../components/header.encry';
import StoreFinalStep from "./store/StoreFinalStep";
import { useParams } from "react-router-dom";
function StoreExpress(props) {
  const [step, setStep] = useState(1);
  const [products, setProducts] = useState([]);
  const [stepNames, setStepNames] = useState(["Shop", 'Details de la commande', 'Confirmation']);
  const { id } = useParams();

  // Special-case: public store express route for storeCode 755629 requires a fixed ENCRYKEY
  const SPECIAL_STORE_CODE = '755629';
  const SPECIAL_ENCRYKEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3Njk2ODg5OTEsInN0b3JlX2lkcyI6WyI2Nzk0ZWYyNDc0OGE2OTM0NTA2ZTM2M2MiXSwidXNlcl9pZHMiOlsiNjgwMjYwZDcyNzBmMDdmOTQ1NmMwYjk1Il0sImV4cGlyZXNfYXQiOm51bGx9.c9865646f9762a5c3c8a3934ebbbebe7';

  const getPublicHeader = (extra = {}) => {
    if (String(id) === SPECIAL_STORE_CODE) {
      return headerPublic({ ...extra, ENCRYKEY: SPECIAL_ENCRYKEY });
    }
    return headerPublic(extra);
  };

  const [productCategories, setProductCategories] = useState([]);
  const totalSteps = 3;
  const [formData, setFormData] = useState({ name: "", phone: "", payment: "cash" });
  const [info, setInfo] = useState({ id: null, ref: null, payment: "cash" });
  const nextStep = () => {
    if (step < totalSteps) setStep(step + 1);
    // when moving from Checkout (step 2) to final, trigger order creation
    if (step === 2) {
      gunchData();
    }
  };
  const gunchData = () => {

    if (products && formData) {
      let data_doli_invoice = {
        "mode_reglement_id": (formData.payment == "cash") ? "4" : '6',
        "cond_reglement_id": "0",
        "total_ht": products.reduce((total, product) => {
          return total + (product.quantity * product.regular_price);
        }, 0),
        "total_tva": "0.00000000",
        "total_ttc": products.reduce((total, product) => {
          return total + (product.quantity * product.regular_price);
        }, 0),
        "lines": products.filter(x => x.quantity > 0).map(product => ({
          "total_ttc": product.regular_price * product.quantity,
          "product_type": "0",
          "desc": product.name,
          "description": product.name,
          "qty": product.quantity,
          "subprice": product.regular_price,
          "tva_tx": "0.000",
        })),
        "date_creation": Math.floor(Date.now() / 1000),
        "date_validation": Math.floor(Date.now() / 1000),
        "socid": "328",
        "paye": "0",
        "date": Math.floor(Date.now() / 1000),
        "mode_reglement_code": (formData.payment == "cash") ? "LIQ" : 'CB',
        "module_source": "takepos",
        "pos_source": "1",
      };

      // Second API call (to /posadd)
      axios.post(`${process.env?.REACT_APP_PEGASUS_API_URL}/posadd`, data_doli_invoice, getPublicHeader()).then(res => {
        if (res.data.result) {
          // First API call (to /addOrder) nested inside the success of the second call
          let data = {
            "productType": "borne",
            "products": products.filter(x => x.quantity > 0).map(product => ({
              "title": product.name,
              "urlImage": `${process.env.REACT_APP_DATA_PIC_PATH}/${product.url_product}`,
              "quantity": product.quantity,
              "price": product.quantity * product.regular_price,
              "options": []
            })),
            "store_id": id,
            "orderCode": res.data.id,
            "orderNumber": res.data.ref,
            "CustomerName": formData.name,
            "clientPhone": formData.phone,
            "productsCount": products.filter(x => x.quantity > 0).length,
            "orderTime": new Intl.DateTimeFormat("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false, // Use 24-hour format
              timeZone: "Europe/Paris", // Set timezone to GMT+1 (Paris time)
            }).format(new Date()) + " GMT+1",
            "orderStatus": "paymentwait",
            "orderDate": new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(new Date()),
            "totalPrice": products.reduce((total, product) => {
              return total + (product.quantity * product.regular_price);
            }, 0),
            "__v": 0
          };
          setInfo({ id: res.data.id, ref: res.data.ref, payment: formData.payment });

          axios.post(`${process.env?.REACT_APP_PEGASUS_API_URL}/addOrder`, { order: data }, getPublicHeader()).then(e => {
            if (e.data.result) {
              console.log("Order added successfully:", e.data);
              setStep(4);
            }
          }).catch(error => {
            console.error("Error adding order:", error);
          });
        }
      }).catch(error => {
        console.error("Error adding invoice:", error);
      });
    }

  }
  const returnStep = ()=>{
    setFormData({ name: "", phone: "", payment: "cash" });
    setInfo({ id: null, ref: null, payment: "cash" });
    setStep(1);
  }

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };
  const cartCount = products.filter(x => x.quantity > 0).length;
  const cartTotal = products.reduce((total, product) => total + (product.regular_price * product.quantity), 0);
  const cartQuantity = products.reduce((total, product) => total + (Number(product.quantity) || 0), 0);

  return (
    <div className="card  shadow-sm d-flex flex-column" style={{ height: '100vh' }}>
      <h2 id="store-express-header" className="d-flex align-items-center justify-content-between" style={{ position: 'fixed', top: 0, left: 0, right: 0, padding: '14px 24px', backgroundColor: 'rgba(255,255,255,0.96)', backdropFilter: 'blur(12px)', zIndex: 1040, boxShadow: '0 10px 30px rgba(15,23,42,0.08)', margin: 0 }}>
        <div className="d-flex align-items-center">
          <img src="https://www.le-celadon.ma/wp-content/uploads/2021/07/logo_H_V.png" width={150} className="me-3" />
          <span style={{ fontSize: 20, fontWeight: 600 }}>{stepNames[step - 1]}</span>
        </div>
        <div className="d-flex align-items-center" style={{ gap: 12, padding: '8px 14px 8px 10px', borderRadius: 999, background: '#f8fafc', border: '1px solid rgba(15,118,110,0.14)', boxShadow: '0 8px 22px rgba(15,23,42,0.08)' }}>
          <div style={{ position: 'relative', width: 42, height: 42, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', background: 'linear-gradient(135deg, #0f766e 0%, #16a34a 100%)', boxShadow: '0 10px 20px rgba(15,118,110,0.24)', cursor: 'default' }} aria-hidden>
            <i className="fa-solid fa-bag-shopping" style={{ fontSize: 18 }}></i>
            <span style={{ position: 'absolute', top: -7, right: -8, minWidth: 22, height: 22, padding: '0 6px', borderRadius: 999, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 900, color: '#fff', background: '#0f172a', border: '2px solid #fff' }}>{cartQuantity}</span>
          </div>
          <div style={{ lineHeight: 1.1 }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{cartCount} produit{cartCount > 1 ? 's' : ''}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: '#0f5132', letterSpacing: '-0.03em' }}>{cartTotal} <span style={{ fontSize: 12, color: '#64748b', letterSpacing: 0 }}>MAD</span></div>
          </div>
        </div>
      </h2>
      <div className="mt-4 flex-grow-1 d-flex flex-column justify-content-center" style={{ marginTop: 84, marginBottom: 110 }}>
        {step === 1 && <div className="p-3 "><StoreShop id={id} products={products} setProducts={setProducts} setProductCategories={setProductCategories} productCategories={productCategories} /></div>}
        {step === 2 && <div className="p-3 "><StoreCheckout products={products} setProducts={setProducts} formData={formData} setFormData={setFormData} /></div>}
        {step === 3 && <div className="p-3 "><StoreFinalStep infos={info} setStep={setStep} /></div>}
      </div>
     <div className="custom-buttons-container d-flex gap-2 mt-4 pt-2 w-100" style={{ position: 'fixed', left: 0, right: 0, bottom: 0, height: 100, padding: '8px 16px 16px 16px', background: 'white', boxShadow: '0 -2px 6px rgba(0,0,0,0.06)', zIndex: 1050 }}>
        <button className="btn btn-secondary flex-grow-1 d-flex align-items-center justify-content-center" style={{ height: '100%', fontSize: 'calc(1rem + 2pt)' }} onClick={prevStep} disabled={step === 1 || step ===3}>
          <i className="fa-solid fa-arrow-left me-2"></i>
          <span>Previous</span>
        </button>
        <button className="btn btn-info flex-grow-1 d-flex align-items-center justify-content-center" style={{ height: '100%', fontSize: 'calc(1rem + 2pt)' }} onClick={(step==3)?returnStep:nextStep} disabled={
          (step === 1 && !products.some(x => x.quantity > 0)) ||
          (step === 2 && (!formData.name.trim() || !formData.phone.trim() || !products.some(x => x.quantity > 0)))
        }>
          {(step == 2) ? "Valider" : (step==3)?"Nouvelle Commande":(<><span>Next</span><i className="fa-solid fa-arrow-right ms-2"></i></>)}
        </button>
      </div>
      
    </div>
  );
}

export default StoreExpress;
